/**
 * File Name          : app.config.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter, withPreloading, PreloadAllModules, Router, NavigationEnd, RouteReuseStrategy } from '@angular/router';
import { AppRouteReuseStrategy } from './reuse-strategy';
import { Meta, Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { routes } from './app.routes';
import { ApplicationInsightsService } from './services/application-insights.service';

function initializeAppInsights(appInsightsService: ApplicationInsightsService) {
  return () => Promise.resolve();
}

const routeMeta: Record<string, { title: string; description: string }> = {
  '/home': {
    title: 'Choose a Unit – Datasnap',
    description: 'Select a physics unit to start collecting real-time sensor data with Datasnap.'
  },
  '/unsupported-browser': {
    title: 'Unsupported Browser – Datasnap',
    description: 'Datasnap requires a Chromium-based browser with Web Bluetooth support.'
  }
};

function initRouteMeta(router: Router, meta: Meta, title: Title) {
  return () => {
    router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(e => {
      const nav = e as NavigationEnd;
      const base = '/' + nav.urlAfterRedirects.split('/')[1];
      const m = routeMeta[base] ?? routeMeta['/home'];
      title.setTitle(m.title);
      meta.updateTag({ name: 'description', content: m.description });
      meta.updateTag({ property: 'og:title', content: m.title });
      meta.updateTag({ property: 'og:description', content: m.description });
    });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(PreloadAllModules)),
    { provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy },
    provideHttpClient(),
    ApplicationInsightsService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppInsights,
      deps: [ApplicationInsightsService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initRouteMeta,
      deps: [Router, Meta, Title],
      multi: true
    }
  ]
};
import config from 'devextreme/core/config'


config({licenseKey: "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjhiMzRlODk1LTIyZTItNGI1Yy1iNzk5LTg1OTliNmM4MTNkYyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.lcyqyMBbTMmSAkvjhgjrDFH3RWIdbotTspZY8BNwcdiZrjMmQ8VU1s6rN5ui37xBI/P+F2212cTQKsv3rXgCBTPOcNSwaSH3cPPSteJW8JzQgqL5eTLz+McJVc2GFVw8u+7zoA=="})